import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=622e3e2e&scoped=true"
import script from "./personnel.vue?vue&type=script&lang=js"
export * from "./personnel.vue?vue&type=script&lang=js"
import style0 from "./personnel.vue?vue&type=style&index=0&id=622e3e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e3e2e",
  null
  
)

export default component.exports